import { useParams, Navigate } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { RevealLine, FadeUp } from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";
import { CALENDLY_URL, LANDING_PAGES } from "../data/content";

const PROOF = [
  "Books closed by the 5th, every month",
  "GST, TDS & statutory compliance handled end-to-end",
  "One point of contact, same-day response",
  "Monthly retainer, no lock-in",
];

export default function LandingPage() {
  const { variant } = useParams();
  const lp = LANDING_PAGES[variant];
  if (!lp) return <Navigate to="/" replace />;

  return (
    <main className="pt-32 pb-16" data-testid={`lp-${variant}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-7">
          <FadeUp y={14}>
            <p className="font-mono text-lg uppercase tracking-[0.25em] text-ink-mid mb-5">{lp.eyebrow}</p>
          </FadeUp>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.04] text-ink mb-8">
            <RevealLine animateOnLoad>{lp.headline[0]}</RevealLine>
            <RevealLine animateOnLoad delay={0.12}><span className="italic text-green">{lp.headline[1]}</span></RevealLine>
          </h1>
          <FadeUp className="max-w-xl text-ink-mid text-lg leading-relaxed mb-12">{lp.sub}</FadeUp>
          <div className="space-y-0 border-t border-rule">
            {PROOF.map((p, i) => (
              <FadeUp key={p} delay={i * 0.06}>
                <div className="flex items-center gap-4 py-5 border-b border-rule" data-testid={`lp-proof-${i}`}>
                  <span className="flex items-center justify-center w-7 h-7 rounded-full bg-green-lt text-green flex-none"><Check size={14} /></span>
                  <p className="text-sm font-medium text-ink">{p}</p>
                </div>
              </FadeUp>
            ))}
          </div>
          <FadeUp delay={0.2} className="mt-10 flex items-center gap-6">
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" data-testid="lp-calendly-btn" className="inline-flex items-center gap-2 bg-green text-white text-sm font-medium px-7 py-4 rounded-sm hover:bg-green-mid transition-colors duration-200">
              Book a free 30-minute call <ArrowUpRight size={15} />
            </a>
            <p className="font-mono text-xs text-ink-soft">No commitment. No sales pitch.</p>
          </FadeUp>
        </div>
        <div className="lg:col-span-5">
          <FadeUp delay={0.15}>
            <div className="bg-white rounded-2xl p-8 lg:p-10 lg:sticky lg:top-28">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-green mb-3">Get a callback</p>
              <h2 className="font-serif text-2xl text-ink mb-8">Tell us what you need.</h2>
              <EnquiryForm source={`lp-${variant}`} compact />
            </div>
          </FadeUp>
        </div>
      </div>
    </main>
  );
}
